import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeviceNotificationService } from '@library/plugin-device-notification/src/public_api';
import { AppSettings } from '@library/plugin-settings/src/public_api';
import moment from 'moment';

@Injectable({
    providedIn: 'root',
})
export class PodcastsNotificationService {
    constructor(private settings: AppSettings,
                private notificationService: DeviceNotificationService,
                private http: HttpClient) {}

    async createPodcastNotifications() {
        await this.settings.awaiter();
        if (navigator.onLine) {
            try {
                this.http.get(`https://mia.de-rena.de/static/mia/podcasts.json`).subscribe(async (data: any) => {
                    const startDate = moment.unix(this.settings.get('init-timestamp'));
                    const podcastNotificationsDates = this.settings.get('podcasts-notifications-dates') || [];

                    if (!podcastNotificationsDates || !podcastNotificationsDates.length) {
                        const allNotifications = await this.notificationService.getPending();
                        const notificationTime = (this.settings.get('notification-time') || '12:00').split(':');
                        const createdPodcastsNotifications = allNotifications.filter(n => n.title === 'MiA Podcasts');

                        if (createdPodcastsNotifications && createdPodcastsNotifications.length) {
                            for(let i = 0; i < createdPodcastsNotifications.length; i++) {
                                let entry = createdPodcastsNotifications[i];
                                try {
                                    await this.notificationService.remove(entry.id);
                                } catch (err) {}
                            }
                        }

                        let newPodcastsNotificationsDates = [];
                        for (let i = 1; i < data.podcasts.length; i++) {
                            const date = moment(startDate).add(data.podcasts[i].unlockAfter, 'days').set('hour', +notificationTime[0]).set('minutes', +notificationTime[1]);
                            this.notificationService.schedule('MiA Podcasts', 'Es ist ein neuer Podcast verfügbar! Hör doch mal rein.', true, date)
                            newPodcastsNotificationsDates.push(date.toISOString());
                        }

                        this.settings.set('podcasts-notifications-dates', newPodcastsNotificationsDates);
                    }
                });
            } catch (error) {
                console.log('error checking podcasts notifications >>>', error);
            }
        }
    }
}
